// Single source of truth for the presale launch moment.
// MUST match the PinkSale pool start time exactly.
export const PRESALE_LAUNCH = new Date("2026-11-12T17:32:00Z");

// Human-friendly label used on transparency links / CTAs.
export const PRESALE_START_LABEL = "Nov 12, 17:32 UTC";

// True once the presale has opened (buying is live on PinkSale).
// Supports a preview override for testing both states without waiting for the date:
//   ?preview=live  -> force post-launch (Buy on PinkSale) state
//   ?preview=pre   -> force pre-launch (waitlist) state
export const isPresaleLive = () => {
  if (typeof window !== "undefined") {
    const p = new URLSearchParams(window.location.search).get("preview");
    if (p === "live") return true;
    if (p === "pre") return false;
  }
  return Date.now() >= PRESALE_LAUNCH.getTime();
};
